import { Bot, Folder, Home } from "lucide-react";
import { IconName } from "lucide-react/dynamic";
import { QuickActionPlacement } from "~/services/quickActions";

export const PLACEMENT_ICON: Record<QuickActionPlacement, typeof Bot> = {
  [QuickActionPlacement.AGENT]: Bot,
  [QuickActionPlacement.DATASET]: Folder,
  [QuickActionPlacement.HOME]: Home,
};

export const PLACEMENT_LABEL: Record<QuickActionPlacement, string> = {
  [QuickActionPlacement.AGENT]: "Agent",
  [QuickActionPlacement.DATASET]: "Dataset",
  [QuickActionPlacement.HOME]: "Home",
};

export const DEFAULT_ICON: IconName = "zap";

/** The agent/dataset display name for an Agent- or Dataset-placed definition,
 *  looked up from a pre-built id -> name map. Null for Home placement, or when
 *  the target isn't in the map (not yet loaded, or since removed). */
export const resolvePlacementTargetName = (
  placement: QuickActionPlacement,
  placementId: string | null,
  agentNamesById: Map<string, string>,
  datasetNamesById: Map<string, string>
): string | null => {
  if (!placementId) {
    return null;
  }
  if (placement === QuickActionPlacement.AGENT) {
    return agentNamesById.get(placementId) ?? null;
  }
  if (placement === QuickActionPlacement.DATASET) {
    return datasetNamesById.get(placementId) ?? null;
  }
  return null;
};

// A curated subset of Lucide icons for the icon picker, matching the set the
// design mockup offered rather than the full ~1700-icon Lucide catalog.
export const ICON_OPTIONS: IconName[] = [
  "zap",
  "file-text",
  "flask-conical",
  "bar-chart-3",
  "message-square",
  "user-plus",
  "shield-check",
  "sparkles",
  "rocket",
  "database",
  "folder",
  "briefcase",
  "clipboard-list",
  "search",
  "settings",
  "bell",
  "calendar",
  "mail",
  "star",
  "heart",
  "bookmark",
  "tag",
  "layers",
  "package",
  "target",
  "trending-up",
  "users",
  "globe",
  "lightbulb",
  "bot",
  "home",
  "layout-grid",
];
